import { createStore, combineReducers, applyMiddleware, compose } from 'redux';
import thunk from 'redux-thunk';
import analyticsReducer from '../reducers/analytics';
import authReducer from '../reducers/auth';
import branchReducer from '../reducers/branches';
import eventsReducer from '../reducers/events';
import voiEventsReducer from '../reducers/voi_events';
import parkingReducer from '../reducers/parking';

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

export default () => {
  const store = createStore(
    combineReducers({
      analytics: analyticsReducer,
      auth: authReducer,
      branches: branchReducer,
      events: eventsReducer,
      parking: parkingReducer,
      voi_events: voiEventsReducer
    }),
    composeEnhancers(applyMiddleware(thunk))
  );

  return store;
};
